@if (fileNotFound) {
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="error-template">
          <h2>
          {{'FILE_NOT_FOUND' | translate}}</h2>
          <h3>
            {{ 'PDF_REPORT_LINK_DEPRECATED' | translate }}
          </h3>
          <p>
            {{ 'REPORT_NOTICE' | translate }}
          </p>
        </div>
      </div>
    </div>
  </div>
}
